export default {
  title: '한국 : React + Typescipt + Redux + RxJs + Multi Language',
};


// WEBPACK FOOTER //
// ./src/locales/zh-CN/home.ts